module.exports = __webpack_public_path__ + "assets/arrow_right_color.5ca59886.svg";